import React, { useRef } from 'react';
import { useSelector } from 'react-redux';
import styled, { css } from 'styled-components';
import { AudioPlayerButton } from '../../_molecules/AudioPlayerButton';
import { AudioProgressWrap } from '../AudioProgressWrap';

const Cd = styled.div`
  background: center /contain no-repeat;
  align-self: center;
  justify-self: center;
  transform-origin: 50% 50%;
  width: 420px;
  height: 420px;
  filter: drop-shadow(0 0 2px rgba(0, 0, 0, 0.20));
  animation: rotate 5s linear infinite;
  animation-play-state: paused;
  
  ${(props) => props.book === 0 ? 'background-image: url(https://content.chungchy.com/PhonicsHero/web_resource/images/audioPlayer/audio_cd1.png);' : (
    props.book === 1 ? 'background-image: url(https://content.chungchy.com/PhonicsHero/web_resource/images/audioPlayer/audio_cd2.png);' : 'background-image: url(https://content.chungchy.com/PhonicsHero/web_resource/images/audioPlayer/audio_cd3.png);'
  )}

  ${(props) => props.page && css`
    align-self: flex-end;
    width: 600px;
    height: 600px;
    filter: drop-shadow(0 2px 3px rgba(0, 0, 0, 0.4));
  `}

  &.act {
    animation-play-state: running;
  }

  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  } 

  &.rewind {
    animation: rewind 0.5s linear 1;
    animation-play-state: running;
  }

  @keyframes rewind {
    100% {
      transform: rotate(-360deg);
    }
  }
`;

export const AudioPlayerWrap = (props) => {
  const state = useSelector((state) => state);
  
  const cd = useRef();
  
  return (
    <>
      <Cd page={props.page} className={[state.track.play ? 'act' : '' , state.track.rewind ? 'rewind' : ''].join(' ')} ref={cd} book={state.book.current_book}/>
      <AudioPlayerButton page={props.page}/>
      <AudioProgressWrap page={props.page}/>
    </>
  );
};